import { QueryClient } from '@tanstack/react-query';

// Shared with non-React code (sagas) so server-state caches can be invalidated after Redux-driven writes.
export const queryClient = new QueryClient();
